// extracted by mini-css-extract-plugin
export default {"wrapper":"Products_wrapper__pyhhK","container":"Products_container__q2Isj"};